import {
  FileExcelOutlined,
  MessageFilled,
  WhatsAppOutlined,
} from "@ant-design/icons";
import "./index.css";
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import { BiRightArrowAlt, BiSolidPurchaseTag } from "react-icons/bi";
import { Divider } from "antd";

const salesItemColumns = [
  {
    columnName: "Price/ Item(₹)",
    key: "Price",
    value: false,
  },
  {
    columnName: "Quantity",
    key: "Qty",
    value: false,
  },
  {
    columnName: "Custom Column",
    key: "CustomColumn",
    value: false,
  },
  {
    columnName: "Travel",
    key: "Travel",
    value: false,
  },
  {
    columnName: "Batch no.",
    key: "batch",
    value: false,
  },
  {
    columnName: "Exp. Date",
    key: "expiryDate",
    value: false,
  },
  {
    columnName: "Mfg Date",
    key: "mfgDate",
    value: false,
  },
];

const createItemsData = [
  {
    columnName: "Item Name",
    key: "itemName",
    value: false,
  },
  {
    columnName: "Item Code",
    key: "itemCode",
    value: false,
  },
  {
    columnName: "Sales Price",
    key: "salesPrice",
    value: false,
  },
  {
    columnName: "Purchase Price",
    key: "purchasePrice",
    value: false,
  },
  {
    columnName: "Current Stock",
    key: "currentStock",
    value: false,
  },
  {
    columnName: "Quantity",
    key: "quantity",
    value: false,
  },
];

const createItemTableData = [
  {
    itemName: "Country Eggs",
    itemCode: "-",
    salesPrice: "-",
    purchasePrice: "-",
    currentStock: "0 pcs",
    quantity: "",
  },
  {
    itemName: "Kadaknath Eggs",
    itemCode: "-",
    salesPrice: "₹ 125",
    purchasePrice: "₹ 100",
    currentStock: "-1 pcs",
    quantity: "",
  },
  {
    itemName: "Fish",
    itemCode: "-",
    salesPrice: "₹ 125",
    purchasePrice: "₹ 100",
    currentStock: "-1 pcs",
    quantity: "",
  },
  {
    itemName: "Labster",
    itemCode: "-",
    salesPrice: "",
    purchasePrice: "",
    currentStock: "1 pcs",
    quantity: "",
  },
];

const HeaderData = [
  {
    key: "date",
    title: "Date",
    dataIndex: "date",
    sorter: (a, b) => a.date.length - b.date.length,
  },
  {
    key: "purchaseInvoice",
    title: "Invoice Number",
    dataIndex: "purchaseInvoice",
  },
  {
    key: "partyName",
    title: "Party Name",
    dataIndex: "partyName",
  },
  {
    key: "dueIn",
    title: "Due In",
    dataIndex: "dueIn",
  },
  {
    key: "amount",
    title: "Amount",
    dataIndex: "amount",
  },
  {
    key: "status",
    title: "Status",
    dataIndex: "status",
  },
];

const TableData = [
  {
    date: "12 Aug 2024",
    purchaseInvoice: "4",
    partyName: "faisal",
    dueIn: "25Days",
    amount: "₹ 900",
    status: "Paid",
  },
  {
    date: "12 Aug 2024",
    purchaseInvoice: "6",
    partyName: "karthick",
    dueIn: "30Days",
    amount: "₹ 300",
    status: "Unpaid",
  },
];
const ledgerStatementList = (
  <div className="hover:rounded-md hover:mr-[-3px] flex justify-between w-[130px] h-[60px] mt-[-12px] pl-3 pr-2 pt-2 pb-2 cursor-pointer">
    <div>
      <p className="flex border-x-0 border-t-0 text-[14px] font-semibold">
        {/* <a href="/parties" className="flex"> */}
        <MessageFilled className="mr-1" />
        SMS
        {/* </a> */}
      </p>
      <Divider className="w-[185%] mt-[4px] ml-[-24px]" />
      <p className="flex mt-[-20px] text-[14px] font-semibold">
        {/* <a href="/parties" className="flex"> */}
        <WhatsAppOutlined className="mr-1" />
        Whatsapp
        {/* </a> */}
      </p>
    </div>
  </div>
);
const salesHeaders = [
  {
    label: "Total Sales",
    key: "1",
    icon: <BiSolidPurchaseTag size={16} />,
    amount: "1,465",
    // color: "blue",
  },
  {
    label: "Paid",
    key: "2",
    icon: <HiOutlineCurrencyRupee size={16} />,
    amount: "336.5",
    // color: "green",
  },
  {
    label: "Unpaid",
    key: "3",
    icon: <HiOutlineCurrencyRupee size={16} />,
    amount: "1,150",
    // color: "red",
  },
];
const items = [
  {
    label: <a href="/reports/sales-report">Sales Report</a>,
    key: "1",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/reports/sales-summary-report">Sales Summary Report</a>,
    key: "2",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/reports/sales-return-report">Sales Return Report</a>,
    key: "3",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/reports/profit-loss-report">Profit Loss Report</a>,
    key: "4",
  },
];
const balaceCollectOptions = [
  {
    label: "To Collect",
    value: "toCollect",
  },
  {
    label: "To Pay",
    value: "toPay",
  },
];
const partyFaqList = [
  {
    key: "1",
    label: "How to change Invoice prefix and sequence number?",
    children: (
      <p className="text-[12px]">
        To set a custom Invoice prefix and sequence number, go to Invoice
        Settings and enable "Invoice Prefix & Sequence Number". After that,
        enter your desired Prefix and Sequence Number.
      </p>
    ),
  },
  {
    key: "2",
    label: "  How to make Cash Sale?",
    children: (
      <p className="text-[12px]">
        Click on "+ Add Additional Charges" below Taxable Amount while creating
        invoice to add charges like delivery charge.
      </p>
    ),
  },
  {
    key: "3",
    label: "How to add Delivery Charge?",
    children: (
      <p className="text-[12px]">
        Click on "+ Add Additional Charges" below Taxable Amount while creating
        invoice to add charges like delivery charge.
      </p>
    ),
  },
  {
    key: "4",
    label: "Can I add Free Items in Invoice?",
    children: (
      <p className="text-[12px]">
        Party balance is the outstanding amount of money that you need to
        collect from or pay to the party. It is calculated based on the Opening
        Balance you entered while creating the party, the invoices(both sales
        and purchase) you made against the party and the payments you made
        to/received from the party.
      </p>
    ),
  },
  {
    key: "5",
    label: "How to show Party Balance in Invoice?",
    children: (
      <p className="text-[12px]">
        To add Free Items to your Invoice easily, enable the option for Free
        Item Quantity from Invoice settings. You will then see a Free QTY button
        for every item added to your invoice.
      </p>
    ),
  },
  {
    key: "6",
    label:
      "How to add PO Number, Eway Bill Number or Vehicle Number to Invoice?",
    children: (
      <p className="text-[12px]">
        These fields can be added to your invoice by enabling them in Invoice
        settings.
      </p>
    ),
  },
  {
    key: "7",
    label:
      "How to add custom item fields of my industry like Batch Number, Size, Expiry etc?",
    children: (
      <p className="text-[12px]">
        Incase you require to add custom item fields like Batch, Size, Color
        etc, you can do that by going to Item Settings and clicking on + Add
        Custom Field. <br />
        To show these item fields in your Invoice after you have added them, you
        need to click on the '+' column/button of the added items table while
        creating Invoice. <br /> You will then see the option to Show/Hide
        custom item fields in Invoice.
      </p>
    ),
  },
  {
    key: "8",
    label: "How is IGST or CGST/SGST applied?",
    children: (
      <p className="text-[12px]">
        Depending on your State(Place of Supply) and your party's Place of
        Supply, it is decided whether IGST(Inter State) or CGST/SGST(Intra
        State) is applicable.
        <br /> Incase the party's place of supply and GSTIN both are missing,
        then IGST is applied by default.
      </p>
    ),
  },
];
const partyTypeOptions = [
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Supplier",
    value: "supplier",
  },
];
const bulkActions = (
  <div>
    <div className="hover:rounded-md hover:bg-[lightgray] hover:mr-[-3px] flex justify-between w-[270px] h-[45px] mt-[-12px] pl-3 pr-2 pt-2 pb-12 cursor-pointer">
      <div>
        <p className="flex text-[14px] font-semibold">
          <FileExcelOutlined className="mr-2" /> Bulk Import IMEI
        </p>
        <p className="mt-1 text-[12px]">
          Quickly add all your IMEI Details with Excel
        </p>
      </div>
      <BiRightArrowAlt size={24} />
    </div>
    <div className="border border-b-0 border-x-0 border-t-1 hover:bg-[lightgray] hover:rounded-md hover:mr-[-3px] flex justify-between w-[270px] h-[55px] mt-[10px] mb-1 pl-3 pr-2 pt-2 pb-8 cursor-pointer">
      <div>
        <p className="flex text-[14px] font-semibold">
          <FileExcelOutlined className="mr-2" /> Bulk Import Product
        </p>
        <p className="mt-1 text-[12px]">
          Quickly add all your Product with Excel
        </p>
      </div>
      <BiRightArrowAlt size={24} />
    </div>
  </div>
);
export {
  items,
  salesHeaders,
  balaceCollectOptions,
  ledgerStatementList,
  TableData,
  partyTypeOptions,
  bulkActions,
  salesItemColumns,
  createItemsData,
  HeaderData,
  createItemTableData,
  partyFaqList,
};
